import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine, Cell } from 'recharts';
import { ChevronDown, TrendingUp, TrendingDown, Target, Info } from 'lucide-react';
const data = [{
  name: 'Week 1',
  cost: 21.5,
  plan: 22
}, {
  name: 'Week 2',
  cost: 23.2,
  plan: 22
}, {
  name: 'Week 3',
  cost: 20.8,
  plan: 22
}, {
  name: 'Week 4',
  cost: 22.1,
  plan: 22
}, {
  name: 'Week 5',
  cost: 21.9,
  plan: 22
}];
export function PnLView() {
  const [selectedWeek, setSelectedWeek] = useState('Week 1');
  return <div className="space-y-6" data-id="element-411">
      <div className="flex items-center justify-between" data-id="element-412">
        <div data-id="element-413">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-414">
            P&L & Food Cost Calculator
          </h2>
          <p className="text-sm text-slate-500" data-id="element-415">
            Interactive recap and performance tracking
          </p>
        </div>
        <div className="relative" data-id="element-416">
          <select value={selectedWeek} onChange={e => setSelectedWeek(e.target.value)} className="appearance-none pl-4 pr-10 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 outline-none transition-all cursor-pointer shadow-sm" data-id="element-417">
            <option data-id="element-418">Week 1</option>
            <option data-id="element-419">Week 2</option>
            <option data-id="element-420">Week 3</option>
            <option data-id="element-421">Week 4</option>
            <option data-id="element-422">Week 5</option>
          </select>
          <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" size={16} data-id="element-423" />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-424">
        {/* Recap Table */}
        <div className="lg:col-span-2 bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-425">
          <div className="p-6 border-b border-slate-50 flex items-center justify-between" data-id="element-426">
            <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wider" data-id="element-427">
              Performance Recap
            </h3>
            <div className="flex gap-4" data-id="element-428">
              <div className="flex items-center gap-1.5" data-id="element-429">
                <div className="w-2 h-2 bg-emerald-500 rounded-full" data-id="element-430" />
                <span className="text-[10px] font-bold text-slate-400 uppercase" data-id="element-431">
                  Current Week
                </span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-432">
                <div className="w-2 h-2 bg-blue-500 rounded-full" data-id="element-433" />
                <span className="text-[10px] font-bold text-slate-400 uppercase" data-id="element-434">
                  MTD
                </span>
              </div>
            </div>
          </div>
          <div className="overflow-x-auto" data-id="element-435">
            <table className="w-full text-left" data-id="element-436">
              <thead data-id="element-437">
                <tr className="bg-slate-50/50" data-id="element-438">
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-439">
                    Metric
                  </th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-440">
                    Current Week
                  </th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-441">
                    MTD
                  </th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-442">
                    Variance
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50" data-id="element-443">
                <RecapRow label="Food Sales" current="$12,450" mtd="$48,200" variance="+4.2%" isPositive data-id="element-444" />
                <RecapRow label="COGS" current="$2,714" mtd="$10,507" variance="-1.2%" isPositive data-id="element-445" />
                <RecapRow label="Food Cost %" current="21.8%" mtd="21.8%" variance="-0.2%" isPositive data-id="element-446" />
                <RecapRow label="Plan (Target)" current="22.0%" mtd="22.0%" variance="0.0%" data-id="element-447" />
              </tbody>
            </table>
          </div>
        </div>

        {/* Plan Info */}
        <div className="bg-purple-600 rounded-2xl p-6 text-white shadow-xl" data-id="element-448">
          <div className="flex items-center gap-2 mb-8" data-id="element-449">
            <Target className="text-purple-200" size={20} data-id="element-450" />
            <h3 className="text-sm font-bold uppercase tracking-wider" data-id="element-451">
              Plan Alignment
            </h3>
          </div>
          <div className="space-y-6" data-id="element-452">
            <div className="text-center py-4" data-id="element-453">
              <p className="text-[10px] font-bold text-purple-200 uppercase tracking-widest mb-1" data-id="element-454">
                MTD Variance
              </p>
              <p className="text-4xl font-black" data-id="element-455">-0.2%</p>
              <p className="text-xs font-bold text-emerald-300 mt-2" data-id="element-456">
                UNDER PLAN (GOOD)
              </p>
            </div>
            <div className="p-4 bg-white/10 rounded-xl border border-white/10" data-id="element-457">
              <div className="flex items-start gap-3" data-id="element-458">
                <Info size={16} className="text-purple-200 shrink-0 mt-0.5" data-id="element-459" />
                <p className="text-[10px] text-purple-100 leading-relaxed font-medium" data-id="element-460">
                  Your current food cost is trending 0.2% below the 22% target.
                  This represents an estimated $1,240 in additional profit for
                  the month.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Visual Chart */}
        <div className="lg:col-span-3 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-461">
          <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-8" data-id="element-462">
            Weekly Food Cost % vs. Plan
          </h3>
          <div className="h-80 w-full" data-id="element-463">
            <ResponsiveContainer width="100%" height="100%" data-id="element-464">
              <BarChart data={data} margin={{
              top: 20,
              right: 30,
              left: 0,
              bottom: 0
            }} data-id="element-465">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F1F5F9" data-id="element-466" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fontSize: 10,
                fontWeight: 700,
                fill: '#94A3B8'
              }} dy={10} data-id="element-467" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 10,
                fontWeight: 700,
                fill: '#94A3B8'
              }} tickFormatter={val => `${val}%`} data-id="element-468" />
                <Tooltip cursor={{
                fill: '#F8FAFC'
              }} contentStyle={{
                borderRadius: '12px',
                border: 'none',
                boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)'
              }} data-id="element-469" />
                <ReferenceLine y={22} stroke="#6366F1" strokeDasharray="5 5" label={{
                position: 'right',
                value: 'Plan (22%)',
                fill: '#6366F1',
                fontSize: 10,
                fontWeight: 800
              }} data-id="element-470" />
                <Bar dataKey="cost" radius={[6, 6, 0, 0]} barSize={40} data-id="element-471">
                  {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.cost > 22 ? '#F43F5E' : '#10B981'} data-id="element-472" />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
}
function RecapRow({
  label,
  current,
  mtd,
  variance,
  isPositive
}: any) {
  return <tr className="hover:bg-slate-50 transition-colors" data-id="element-473">
      <td className="px-6 py-4 text-sm font-bold text-slate-700" data-id="element-474">{label}</td>
      <td className="px-6 py-4 text-sm font-black text-slate-900" data-id="element-475">{current}</td>
      <td className="px-6 py-4 text-sm font-black text-slate-900" data-id="element-476">{mtd}</td>
      <td className="px-6 py-4" data-id="element-477">
        <div className={`flex items-center gap-1 text-xs font-bold ${variance === '0.0%' ? 'text-slate-400' : isPositive ? 'text-emerald-600' : 'text-rose-600'}`} data-id="element-478">
          {variance !== '0.0%' && (isPositive ? <TrendingDown size={14} data-id="element-479" /> : <TrendingUp size={14} data-id="element-480" />)}
          {variance}
        </div>
      </td>
    </tr>;
}